import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  ref: "imagetransfer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_appHead = _resolveComponent("appHead");
  const _component_uploadImage = _resolveComponent("uploadImage");
  const _component_pixelArtList = _resolveComponent("pixelArtList");
  const _component_pixelArtDetails = _resolveComponent("pixelArtDetails");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_appHead, {
    headImgUrl: $props.headImgUrl,
    product_introduce: $props.product_introduce,
    carousel_01: $props.carousel_01,
    carousel_02: $props.carousel_02,
    carousel_03: $props.carousel_03,
    carousel_04: $props.carousel_04,
    carousel_05: $props.carousel_05,
    carousel_06: $props.carousel_06,
    ex_original: $props.ex_original,
    ex_target: $props.ex_target,
    shopUrl: $props.shopUrl
  }, null, 8, ["headImgUrl", "product_introduce", "carousel_01", "carousel_02", "carousel_03", "carousel_04", "carousel_05", "carousel_06", "ex_original", "ex_target", "shopUrl"]), _createVNode(_component_uploadImage, {
    ref: "uploadImage",
    uploadUrl: $data.uploadUrl,
    createButImg: $data.createButImg,
    product_type: $props.product_type,
    onOnBeforeUpload: $options.onBeforeUpload,
    onOnUploadSucceed: $options.onUploadSucceed,
    onOnUploadFailed: $options.onUploadFailed,
    onStartcrop: $options.onStartcrop
  }, null, 8, ["uploadUrl", "createButImg", "product_type", "onOnBeforeUpload", "onOnUploadSucceed", "onOnUploadFailed", "onStartcrop"]), _createVNode(_component_pixelArtList, {
    refreshing: $data.uploading,
    dataList: $data.currentDataList,
    onOnSelected: $options.onSelectedPixelArt
  }, null, 8, ["refreshing", "dataList", "onOnSelected"]), _createVNode(_component_pixelArtDetails, {
    ref: "pixelArtDetails",
    show: $data.showDetails,
    currentEffectimg: $data.currentEffectimg,
    currentimgInfo: $data.currentimgInfo,
    particelImg: $data.selectedParticleImg,
    onOnClicklike: $options.onClicklike
  }, null, 8, ["show", "currentEffectimg", "currentimgInfo", "particelImg", "onOnClicklike"])], 512);
}